import { CustomBox } from "components";
import { PaidSubscriptionIcon } from "pages/internal-dashboard/icons";
import { getGrowthTrends } from "../../helpers";

export function UsersWithSubscription({ data, isLoading }: any) {
  const { today, thisWeek, thisMonth, thisYear, total } = data || {};

  const growthTrends = getGrowthTrends(data);

  return (
    <CustomBox
      loading={isLoading}
      color="#F3B924"
      title="Users with paid subscriptions"
      userCount={total || 0}
      boxData={{
        label: "Paid Subscribers",
        description:
          "Users who have an active, paid subscription to the platform.",
        todayCount: today || 0,
        weekCount: thisWeek || 0,
        monthCount: thisMonth || 0,
        yearCount: thisYear || 0,
        icon: PaidSubscriptionIcon,
      }}
      percentages={growthTrends}
    />
  );
}
